import { Modal, ModalBody, ModalHeader } from "reactstrap"

import { IModel } from "@api/schema"
import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces"
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n"


import OnboardingComponent, { IProps as OnboardingComponentProps } from "./OnboardingComponent"

const usedNamespaces: NamespaceShortcut[] = ["onboarding"]

type IProps = {
  modal: boolean
  toggleModal: () => void
}

type CombinedProps<T> = IProps & OnboardingComponentProps<T>

/**
 * This component encapsulates the `OnboardingComponent` in a modal dialog.
 */
const OnboardingModal: React.FC<CombinedProps<IModel>> = <T extends IModel>(props: CombinedProps<T>) => {

  const t = useDynamicTranslation()

  return <Modal isOpen={props.modal} toggle={props.toggleModal}>
    <ModalHeader>
      <span>{t("onboarding", "accountRequired")}</span>
    </ModalHeader>
    <ModalBody>
      <OnboardingComponent
        {...props}
      />
    </ModalBody>
  </Modal>
}

export default withDynamicNamespaces<CombinedProps<IModel>>(OnboardingModal, usedNamespaces)
